import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { Row, Col, Button, Radio, Collapse, Alert } from 'antd';
import UserManagerContext from '../context/UserManagerContext';
import ConnectedHeader from '../connectedComponents/ConnectedHeader';
import Navigation from './navigation';
import Definition from '../components/Definition/Definition';
import DatasetsList from '../components/DatasetsList/DatasetsList.js';
import Initiate from './initiate';
import Agreement from './agreement';
import AgreementSign from './agreement/sign';
import CoreDefine from './core/core-define';
import Upload from './upload';
import MarkTask from './markTask';
import useSearchParams from '@ohif/viewer/src/customHooks/useSearchParams';
import './index.less';

const components = [
  { pathname: '/research/definition', component: Definition },
  { pathname: '/research/initiate', component: Initiate },
  { pathname: '/research/agreement', component: Agreement },
  { pathname: '/research/upload', component: Upload },
  { pathname: '/research/markTask', component: MarkTask },
];

const Research = () => {
  const [tab, setTab] = useState('data');
  const [mainPanel, setMainPanel] = useState('data');
  const [childProps, setChildProps] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [clearn, setClearn] = useState(false);
  const history = useHistory();

  // const rowValue =  async e => {
  //   if (e.opt == 3 && history.location.pathname !== '/research/definition') {
  //     history.push({
  //       pathname: '/research/definition',
  //     });
  //   }
  //   const lockId = localStorage.getItem('lock');
  //   setChildProps({
  //     item: e,
  //     id: e.id,
  //     disabled:
  //       (lockId && lockId !== 'null' && e.id.toString() !== lockId) ||
  //       e.p1 == '1',
  //   });
  // };

  const rowValue = useCallback(
    e => {
      if (
        e.original.opt == 3 &&
        history.location.pathname !== '/research/definition'
      ) {
        history.push({
          pathname: '/research/definition',
        });
      }
      const lockId = localStorage.getItem('lock');
      setChildProps({
        item: e.original,
        id: e.original.id,
        disabled:
          (lockId &&
            lockId !== 'null' &&
            e.original.id.toString() !== lockId) ||
          e.original.p1 == '1',
      });
    },
    [history]
  );

  const onChildChange = async e => {
    setRefresh(!refresh);
  };

  const aiAssistChange = () => {
    setChildProps({});
    setChildProps(childProps);
  };

  const onChangeRouter = data => {
    switch (data.url) {
      // 如果是跳转定义就清空数据
      case components[0].pathname:
        if (!localStorage.getItem('lock')) {
          setChildProps({});
          setClearn(!clearn);
        }
        break;
      // 跳转协议
      case components[2].pathname:
        break;
    }
  };

  // 更新协议列表
  const handleResetAgreement = () => {
    if (history.location.pathname !== '/research/agreement') return;
    setChildProps({});
    setChildProps(childProps);
  };

  const [searchParams, joinSearch] = useSearchParams();
  const searchParamsRef = useRef(searchParams);
  searchParamsRef.current = searchParams;
  useEffect(() => {
    const { location } = history;
    const search = searchParamsRef.current;
    if (childProps.id) search.pro = childProps.id;
    history.replace({
      ...location,
      search: joinSearch(search),
    });
  }, [childProps, history, joinSearch]);

  return (
    <>
      <UserManagerContext.Consumer>
        {userManager => <ConnectedHeader userManager={userManager} />}
      </UserManagerContext.Consumer>
      <div className="research">
        <Row justify="space-between">
          <Col>
            <Radio.Group value={tab} onChange={e => setTab(e.target.value)}>
              <Radio.Button value="data">数据界面</Radio.Button>
              <Radio.Button value="app">应用界面</Radio.Button>
              <Radio.Button value="manage">管理界面</Radio.Button>
            </Radio.Group>
          </Col>
          <Col>
            {/* 核心定义表 （st和正式环境先注释掉） */}
            <CoreDefine {...childProps} onChange={e => aiAssistChange(e)} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Collapse
              ghost
              expandIcon={() => null}
              activeKey={mainPanel}
              onChange={setMainPanel}
            >
              <Collapse.Panel
                key="data"
                header={
                  <Row style={{ width: '100%' }}>
                    <Col span={6}>
                      <Button type="primary">大数据集流程</Button>
                    </Col>
                    <Col span={18}>
                      <Navigation {...childProps} onChange={onChangeRouter} />
                    </Col>
                  </Row>
                }
              >
                <DatasetsList
                  getRowValue={rowValue}
                  isRefresh={refresh}
                  isClearn={clearn}
                  style={{
                    height: '270px',
                  }}
                />
                <Switch>
                  {components.map(
                    ({ pathname, component: Component }, index) => (
                      <Route key={index} path={pathname}>
                        {childProps.id ||
                        [components[0].pathname].includes(pathname) ? (
                          <Component
                            {...childProps}
                            onChange={e => onChildChange(e)}
                          />
                        ) : (
                          <Alert
                            showIcon
                            type="error"
                            message="必须选中一个项目"
                          />
                        )}
                      </Route>
                    )
                  )}
                </Switch>
                <AgreementSign
                  {...childProps}
                  onChange={handleResetAgreement}
                />
              </Collapse.Panel>
              <Collapse.Panel
                key="crowd"
                header={<Button type="primary">众筹产品流程</Button>}
              ></Collapse.Panel>
              <Collapse.Panel
                key="study"
                header={<Button type="primary">科研管理流程</Button>}
              ></Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Research;
